import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { X } from "lucide-react";

const KEY = "rb-cookie-ack";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {}
  }, []);

  if (!show) return null;

  function dismiss() {
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setShow(false);
  }

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100vw-2rem)] max-w-md">
      <div className="rounded-2xl border border-border bg-background/95 backdrop-blur-xl shadow-lg shadow-black/10 px-4 py-3 flex items-center gap-3">
        <p className="text-xs text-muted-foreground flex-1 leading-relaxed">
          We use minimal analytics to improve RoleBoard. See our{" "}
          <Link to="/privacy" className="underline underline-offset-2 hover:text-foreground">
            Privacy Policy
          </Link>
          .
        </p>
        <button
          onClick={dismiss}
          className="text-xs font-medium px-2.5 py-1 rounded-md hover:bg-muted transition-colors"
        >
          Got it
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="text-muted-foreground hover:text-foreground"
        >
          <X className="size-3.5" />
        </button>
      </div>
    </div>
  );
}
